<pvmo-page id="page-subscription" [hidden]="!isUserConnected()">
</pvmo-page>
